import React, { Component } from 'react';
import SectionTitle from './SectionTitle';
import SectionBar from './SectionBar';
import Prettyfier from 'components/Prettyfier';
import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';
// import { Link } from 'react-router-dom';

class ParagraphNumber extends Component {
  render() {
    const { color, number, style, forceNumber } = this.props;
    let fontSize = '100%';
    const ln = number.toString().length;
    if (ln >= 6)
    fontSize = '55%';
    else if (ln >= 5)
    fontSize = '65%';
    else if (ln >= 4)
    fontSize = '75%';
    else if (ln >= 3)
    fontSize = '85%';
// console.log('number is', number)
    if ((number === -1 || number === 0 || number === '0') && forceNumber !== true)
    return <span className="numberPlaceholder" style={{ ...style}}></span>
    else
    return <span className="numberWrapper" style={{backgroundColor: color, fontSize, ...style}}><span className="number">{number}</span></span>
  }
}
class SectionList extends Component {

  render() {
    const { id, data, barOffset, align, className, title, titleIcon, header, footer, barColor, titleColor, titleAlign, sectionBg, style, showContent, titleSize, forceNumber, forceVisibility } = this.props;
    let sectionBarStyle, sectionParagraphStyle;
    if (align === 'left') {
      sectionBarStyle = {marginLeft: barOffset*-1+'px', position: 'absolute'};
      sectionParagraphStyle = {
        marginLeft: (barOffset+24)*-1+'px',
      };
    } else if (align === 'right') {
      sectionBarStyle = {marginLeft: barOffset*1+'px', position: 'absolute'};
      sectionParagraphStyle = {
        marginRight: (barOffset+30)*-1+'px',
      };
    } else {
      sectionBarStyle = {marginLeft: 0, position: 'absolute'};
      sectionParagraphStyle = {
        // marginLeft: 0+'px',
      };
    }

    let bg;


    return (
      <section id={id} className={'Section '+className+' SectionList '+align} style={style}>
        <div style={{height: '100%', position: 'relative'}}>
          <div className="section">
            {header}
            <SectionBar length={'100%'} color={barColor} style={sectionBarStyle} direction={'vertical'}/>
            <SectionTitle title={title} color={titleColor || '#fff'} icon={titleIcon} align={titleAlign || align} titleSize={titleSize}/>

          </div>
          <Choose>
          <When condition={data !== undefined}>
          {data.map((section, s) => {
            bg = section.get('background') !== undefined && section.get('background') !== 'inherit' ? 'url('+section.get('background')+')' : 'inherit';

            return <div key={'s_'+s} className="section">
              <If condition={bg !== undefined && bg !== ''}>
                <Zoom>
                  <div className="bg" style={{ ...(section.get('backgroundStyle') ? section.get('backgroundStyle').toJS() : {}),
                    ...(bg !== 'inherit' ? {backgroundImage: bg} : {})
                  }}>
                </div>
              </Zoom>
            </If>

            <SectionBar length={'100%'} color={barColor} style={sectionBarStyle} direction={'vertical'}/>

            {(section.get('items').map((paragraph, p) => <div key={'sp_'+s+'_'+p} className={'paragraph'+(section.get('bullets') !== false ? ' indented' : ' indented')+(align === 'center' ? (p % 2 ? ' zebra' : ''): '')} style={sectionParagraphStyle}>
            <Fade when={forceVisibility} delay={200}>
              <div style={{height: '100%', position: 'relative'}}>
                <span className={'titleWrapper'} style={{
                    textAlign: paragraph.get('titleAlign') || 'inherit',
                    color: paragraph.get('titleColor') || 'inherit',

                  }}>
                  <If condition={section.get('bullets') === 'numbers' && (align === 'left' || (align === 'center' && !(p % 2)))}>
                    <ParagraphNumber color={paragraph.get('color') || paragraph.get('numberColor')}  number={paragraph.get('number') || '0'} forceNumber={forceNumber} style={{}}/>
                  </If>
                  <If condition={paragraph.get('title') !== undefined || paragraph.get('titleImage') !== undefined}>
                    <span className="title">
                      <If condition={paragraph.get('title') !== undefined}>
                        {paragraph.get('title')}
                      </If>
                      <If condition={paragraph.get('titleImage') !== undefined && paragraph.get('titleImage') !== false}>
                        <If condition={paragraph.get('titleImage') !== undefined &&paragraph.get('link') != ""}>
                          <a target="_blank" href={paragraph.get('link')}><img src={paragraph.get('titleImage')} alt="..." /></a>
                        <Else/>
                          <img src={paragraph.get('titleImage')} alt="..." />
                        </If>
                      </If>
                    </span>
                  </If>
                  <If condition={section.get('bullets') === 'numbers' && (align === 'right' || (align === 'center' && (p % 2)))}>
                    <ParagraphNumber color={paragraph.get('color') || paragraph.get('numberColor')}  number={paragraph.get('number') || '0'} style={{}} forceNumber={forceNumber} />
                  </If>
                </span>
                <If condition={showContent !== false}>
                  <span className="content" style={{
                      textAlign: paragraph.get('contentAlign') || 'inherit',
                      color: paragraph.get('contentColor') || 'inherit',
                    }}>
                    <If condition={paragraph.get('content') !== undefined && paragraph.get('content') !== ''}>
                      <Prettyfier text={paragraph.get('content')}/>
                    </If>
                    <If condition={paragraph.get('items') !== undefined}>
                      {paragraph.get('items').map((item, i) => {
                        return <span key={'sitem_'+i} className={'item'+(item.get('size') !== undefined ? ' size'+item.get('size') : '')}>
                          <If condition={item.get('image') !== undefined && item.get('image') !== false}>
                            <If condition={item.get('url') === undefined || item.get('url') === ''}>
                              <span className={'image'} style={{backgroundImage: 'url('+item.get('image')+')'}}></span>

                            </If>
                            <If condition={item.get('url') !== undefined && item.get('url') !== ''}>
                              <a href={item.get('url')} target="_blank"><span className={'image'} style={{backgroundImage: 'url('+item.get('image')+')'}}></span></a>

                            </If>
                        </If>

                          <span className="title" style={{color: item.get('titleColor') || 'inherit'}}>{item.get('title')}</span>
                          <span className="text">{item.get('text')}</span>
                        </span>
                      }).toArray()}
                    </If>
                  </span>
                </If>
              </div>
            </Fade>
          </div>)).toArray()}
        </div>}).toArray()}
        <If condition={footer}>{footer}</If>
        </When>
        <Otherwise>No data !</Otherwise>
      </Choose>
        <If condition={sectionBg !== undefined}>
          <Fade delay={500} left>
            <div className="bg left"></div>
          </Fade>
          <Fade delay={500} right>
            <div className="bg right"></div>
          </Fade>
        </If>
      </div>
    </section>

  );
}
}

export default SectionList;



// WEBPACK FOOTER //
// ./src/components/Home/Section/SectionList.jsx